import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ChoiceButtonProps {
  label: string;
  icon?: BoxIcon;
  selected?: boolean;
  onClick: () => void;
  delay?: number;
}
export function ChoiceButton({
  label,
  icon: Icon,
  selected,
  onClick,
  delay = 0
}: ChoiceButtonProps) {
  return <motion.button initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay,
    ease: 'easeOut'
  }} whileTap={{
    scale: 0.97
  }} onClick={onClick} className={`w-full min-h-[64px] p-4 rounded-2xl flex items-center gap-4 text-left transition-all duration-300 border relative overflow-hidden
        ${selected ? 'bg-minerva-blue border-minerva-blue text-white shadow-[0_8px_24px_-6px_rgba(0,133,189,0.5)]' : 'bg-white/85 backdrop-blur-md border-slate-200 text-slate-900 hover:bg-white hover:border-minerva-blue/40 hover:shadow-md'}`} data-id="element-22">
      {Icon && <div className={`p-2 rounded-xl flex-shrink-0 ${selected ? 'bg-white/20' : 'bg-minerva-blue/10'}`} data-id="element-23">
          <Icon size={20} className={selected ? 'text-white' : 'text-minerva-blue'} data-id="element-24" />
        </div>}

      <span className="font-medium text-base sm:text-lg flex-1" data-id="element-25">{label}</span>

      {selected && <motion.div initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} className="w-2 h-2 rounded-full bg-white shadow-[0_0_8px_#fff]" data-id="element-26" />}
    </motion.button>;
}